// Skills Icons
// import htmlIcon from "./images/html.svg"
// import cssIcon from "./images/css.svg"
// import reactIcon from "./images/react.svg"
// import jsIcon from "./images/javascript.svg"
// import designIcon from "./images/design.svg"
// import codeIcon from "./images/code.svg"
import { DiUnitySmall } from "@react-icons/all-files/di/DiUnitySmall";
import { DiMongodb } from "@react-icons/all-files/di/DiMongodb";
import { DiCss3 } from "@react-icons/all-files/di/DiCss3";
import { DiHtml5 } from "@react-icons/all-files/di/DiHtml5";
import { DiReact } from "@react-icons/all-files/di/DiReact";
import { SiUnrealengine } from "@react-icons/all-files/si/SiUnrealengine";
import { SiCsharp } from "@react-icons/all-files/si/SiCsharp";
import { DiJavascript1 } from "@react-icons/all-files/di/DiJavascript1";
import { DiPhotoshop } from "@react-icons/all-files/di/DiPhotoshop";
import { DiWordpress } from "@react-icons/all-files/di/DiWordpress";
import { DiPython } from "@react-icons/all-files/di/DiPython";
import { DiNodejs } from "@react-icons/all-files/di/DiNodejs";


// Social Icon
// import githubIcon from "./images/github.svg"
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

import twoboxesthx from "./images/2boxesthx.png"
import howlongistheline from "./images/howlongistheline.png"
import ninja from "./images/ninja.jpg"
import narau from "./images/narau.jpg"
import assassin from "./images/assassin.jpg"
import BomBomBaRocketGo from "./images/bombomba.jpg"
import basketball from "./images/basketball.jpg"
import cycling from "./images/cycling.jpg"
import racing from "./images/racing.jpg"
import shootball from "./images/shootball.png"
import mini1 from "./images/mini1.png"
import mini2 from "./images/mini2.jpeg"
import fwen from "./images/fwen.jpeg"
import BicycleFest from "./images/BicycleFest.jpg"
import EKayak from "./images/kayak.jpg"
import transparenttv from "./images/transparentTV.jpeg"
import photoBooth from "./images/PhotoBooth.jpeg"
import projectionMap from "./images/projectionMap+RFID.jpeg"


// import CSharp from "./images/CSharp.png" 
// import javascript from "./images/javascript.png"
// import mongodb from "./images/mongodb.png"
// import meteor from "./images/meteor.png"
// import react from "./images/react.png"
// import unity from "./images/unity.jpg"
// import html from "./images/html.png"
// import css from "./images/css.png"

import aboutme from "./images/aboutme_3.jpg"

export default {
  //(Please Do Not Remove The comma(,) after every variable)
  //Change The Website Template

  //   Header Details ---------------------
  name: "Louis Lui",
  headerTagline: [
    //Line 1 For Header
    "Louis Lui",
    //Line 2 For Header
    "Game Developer",
    //Line 3 For Header
    "Work Hard Play Hard",
  ],
  //   Header Paragraph
  headerParagraph:
    "",

  //Contact Email
  contactEmail: "louisluigood@gmail.com",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      id: 1, //DO NOT CHANGE THIS (Please)😅
      title: "FWEN Metaverse", //Project Title - Add Your Project Title Here
      para:
        "IOS/Android multiplayer metaverse game, a world for players to social and play different games. including but not only a 3v3 shooting game.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: fwen,
            //Project URL - Add Your Project Url Here
      url: "https://twitter.com/fwenclub/status/1676184874640875521",
    },
    {
      id: 3, //DO NOT CHANGE THIS (Please)😅
      title: "The Secret Dungeon", //Project Title - Add Your Project Title Here
      para:
        "A solo/multi-player free falling mini game, player need to survive while keep falling", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: mini2,
            //Project URL - Add Your Project Url Here
      url: "https://the-secret-dungeon.polkafantasy.com/",
    },
    {
      id: 4, //DO NOT CHANGE THIS (Please)😅
      title: "Mana Rush", //Project Title - Add Your Project Title Here
      para:
        "A mini game which require player to jump and attack to avoid the obstacles", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: mini1,
            //Project URL - Add Your Project Url Here
      url: "https://mana-rush.polkafantasy.com/WebGL.wasm.unityweb",
    },
    {
      id: 5, //DO NOT CHANGE THIS (Please)😅
      title: "Shiseido Travel Retail - Projection Map with IR detection", //Project Title - waiting for final title
      para:
        "A projection map with IR detection for Shiseido Travel Retail. Player interaction is enabled through infrared sensors.", //Project Description - waiting for your text
      imageSrc: projectionMap,
      //Project URL - Add Your Project Url Here
      url: "",
    },
    {
      id: 6, //DO NOT CHANGE THIS (Please)😅
      title: "Shiseido Travel Retail - Photobooth", //Project Title - waiting for final title
      para:
        "A photobooth experience for Shiseido Travel Retail. Users can take photos with branded overlays and share them on social media.", //Project Description - waiting for your text
      imageSrc: photoBooth,
      //Project URL - Add Your Project Url Here
      url: "",
    },
    {
      id: 7, //DO NOT CHANGE THIS (Please)😅
      title: "Shiseido Travel Retail - Transparent TV", //Project Title - waiting for final title
      para:
        "A transparent TV experience for Shiseido Travel Retail. Users can view content through a transparent display while interacting with it.", //Project Description - waiting for your text
      imageSrc: transparenttv,
      //Project URL - Add Your Project Url Here
      url: "",
    },
    {
      id: 8, //DO NOT CHANGE THIS (Please)😅
      title: "E-Horse", //Project Title - Add Your Project Title Here
      para:
        "A multi-player horse racing VR game, players need to ride on a physical horse and put on VR to compete with other players", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: racing,
            //Project URL - Add Your Project Url Here
      url: "",
    },
    {
      id: 9, //DO NOT CHANGE THIS (Please)😅
      title: "E-Cycling", //Project Title - Add Your Project Title Here
      para:
        "A cycling game which allows players to ride on a real bicycle with dynamic resistance according to the slope in-game.",
      //Project Image - Add Your Project Image Here
      imageSrc: cycling,
       //Project URL - Add Your Project Url Here
      url: "",
    },
    {
      id: 10, //DO NOT CHANGE THIS (Please)😅
      title: "E-BicycleFestival", //Project Title - Add Your Project Title Here
      para:
        "A Hong Kong Tourism Board virtual cycling experience: a free 26km HKZM Bridge route with realistic slope resistance, boost zones, and live ranking.",
      //Project Image - Add Your Project Image Here
      imageSrc: BicycleFest,
       //Project URL - Add Your Project Url Here
      url: "",
    },
    {
      id: 11, //DO NOT CHANGE THIS (Please)😅
      title: "E-Basketball/E-football", //Project Title - Add Your Project Title Here
      para:
        "A basketball & football game which player to pass & shoot on the sensor wall.",
      //Project Image - Add Your Project Image Here
      imageSrc: basketball,
       //Project URL - Add Your Project Url Here
      url: "",
    },
    {
      id: 12, //DO NOT CHANGE THIS (Please)😅
      title: "E-kayak", //Project Title - waiting for final title
      para:
        "A kayaking experience in real kayak simulator. Players can paddle and navigate through virtual water environments.", //Project Description - waiting for your text
      imageSrc: EKayak,
      //Project URL - Add Your Project Url Here
      url: "",
    },
    {
      id: 2, //DO NOT CHANGE THIS (Please)😅
      title: "Shootball", //Project Title - Add Your Project Title Here
      para:
        "A hackathon award winning project that completed in a few days. multi-player football game, players choose different characters with different ability to beat others", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: shootball,
            //Project URL - Add Your Project Url Here
      url: "https://devpost.com/software/shoot-ball",
    },
    {
      id: 13, //DO NOT CHANGE THIS (Please)😅
      title: "BomBomBaRocketGo!", //Project Title - Add Your Project Title Here
      para:
        "A mobile game made with Unity engine which has been upload to the Google play store. A Unlimited Scroll Game",      //Project Image - Add Your Project Image Here
      imageSrc: BomBomBaRocketGo,
        //Project URL - Add Your Project Url Here
      url: "https://youtu.be/veV7BjT0RVo",
    },
  ],

  // End Work Section -----------------------

  // About Secton --------------
  aboutParaOne:
    "I am an experienced game developer with both AAA and interactive project experience.",
  aboutParaTwo:
    "I work with Unreal Engine and Unity, and I enjoy turning ideas into engaging games that players can truly enjoy.",
  aboutParaThree:
    "I am always learning, collaborating, and improving to deliver high-quality experiences and bring positive energy to every project.",
  aboutImage:
    // "https://images.unsplash.com/photo-1519713958759-6254243c4a53?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80",
    aboutme,
  //   End About Section ---------------------

  // Skills Section ---------------

  //   Import Icons from the top and link it here

  skills: [
    {
      id: 1,
      img: DiUnitySmall,
      description: "Unity"
    },
    {
      id: 2,
      img: SiUnrealengine,
      description: "Unreal Engine"
    },
    {
      id: 3,
      img: DiJavascript1,
      description: "javascript"
    },
    {
      id: 4,
      img: SiCsharp,
      description: "C#"
    },
    {
      id: 5,
      img: DiReact,
      description: "React"
    },
    {
      id: 6,
      img: DiMongodb,
      description: "Mongodb"
    },
    {
      id: 7,
      img: DiHtml5,
      description: "html5"
    },
    {
      id: 8,
      img: DiCss3,
      description: "Css"
    },
    {
      id: 9,
      img: DiPhotoshop,
      description: "Photoshop"
    },
    {
      id: 10,
      img: DiWordpress,
      description: "WordPress"
    },
    {
      id: 11,
      img: DiNodejs,
      description: "NodeJs"
    },
    {
      id: 12,
      img: DiPython,
      description: "Python"
    }
  ],

  // End Skills Section --------------------------
  // End Promotion Section -----------------

  //   Contact Section --------------

  contactSubHeading: "Feel Free to contact me by email or Linkedin!",
  social: [
    // Add Or Remove The Link Accordingly
    { img: GitHubIcon, url: "https://github.com/ioioio8888" },
    {
      img: LinkedInIcon,
      url: "https://www.linkedin.com/in/louis-lui-7b7a2a146/",
    }
  ],

  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
